import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type ProjectMembershipNotFoundErrorOptions =
  | { user: ObjectId; project: ObjectId }
  | {
      membership: ObjectId;
      project: ObjectId;
    };

export class ProjectMembershipNotFoundError extends FleekError<ProjectMembershipNotFoundErrorOptions> {
  public name = 'ProjectMembershipNotFoundError';

  toString = () => `Membership not found for project.`;
}
